import WorkoutBanner from "../workoutBanner";
import Workout from "../../../assets/images/webp/programs/onlineMain.webp";
import WorkoutFeature from "../workoutFeature";
import WorkoutSetup from "../workoutSetup";
import SlidingText from "../../../components/SlidingText";
import TestimonialCarousel from "../../../components/TestimonialCarousel";
import WorkoutsImageGroup from "../../../components/WorkoutsImageGroup";

import featureOne from "../../../assets/images/webp/programs/featureOne.webp";
import featureThree from "../../../assets/images/webp/programs/featureThree.webp";
import featureFour from "../../../assets/images/webp/programs/featureFour.webp";

import "../index.scss";
import CONSTANTS from "../../../utils/constants/CONSTANTS";

const Online = () => {
  const featureData = [
    {
      featureImg: featureOne,
      title: "Customized plans for your goals",
      description: "Step by step guidance and video assistance",
    },
    {
      featureImg: featureFour,
      title: "Stay in touch with your trainer",
      description:
        "Use the in-app messenger to keep in contact with your trainer, whether you need answers to questions or simply some extra motivation",
    },
    {
      featureImg: featureThree,
      title: "Take your workouts anywhere",
      description: "Have access to a great workout wherever you are!",
    },
  ];
  return (
    <div className="online-workout">
      <WorkoutBanner
        mainHeading="Online"
        workoutImage={Workout}
        mainDescription="With our world-class digital training experience, you get everything you need to get started and stay on track. Omni-Active® has helped thousands of users get stronger, healthier, and perform better thanks to customized workouts and access to our elite training staff.”"
        description="Workout with instructions for each set, videos to follow along with, and step-by-step instructions."
        subDescription="Unlike other fitness apps, these aren’t cookie cutter programs based on fancy algorithms. We prefer doing the dirty work ourselves. Our team of elite trainers will build your workouts based on your goals to help you reach your fitness goals  effectively and efficiently."
      />
      <div className="program-testimonials">
        <TestimonialCarousel images={CONSTANTS.onlineTestimonials} />
      </div>
      <div className="workout-features">
        {featureData.map((feature, index) => {
          return (
            <WorkoutFeature
              key={index}
              featureImg={feature.featureImg}
              title={feature.title}
              description={feature.description}
            />
          );
        })}
      </div>
      <WorkoutSetup
        description="Taking our customized, convenient, and creative approach one step further, virtual training with Omni-Active Fitness allows our clients to get a great workout, regardless of their whereabouts."
        pointOne="Sign up & subscribe for online workouts"
        pointTwo="Answer the questions prompted within the app"
        pointThree="Start with your workouts right away, receiving updated plans each month!"
      />
      <div className="workout-imgs">
        <WorkoutsImageGroup
          phoneOne={CONSTANTS.phoneOne}
          phoneTwo={CONSTANTS.phoneTwo}
          phoneThree={CONSTANTS.phoneThree}
          phoneFour={CONSTANTS.phoneFour}
          phoneFive={CONSTANTS.phoneFive}
          programsPage={false}
        />
      </div>
      <SlidingText heading="Workout wherever you want" subHeading="whenever you want" />
    </div>
  );
};
export default Online;
